import React, { useEffect, useState } from "react";
import { CRMLayout } from "@/components/CRMLayout";
import { api } from "@/lib/api";

const STATUS_COLOR = {
  pending: "bg-amber-100 text-amber-800",
  approved: "bg-emerald-100 text-emerald-800",
  rescheduled: "bg-blue-100 text-blue-800",
  cancelled: "bg-rose-100 text-rose-800",
};

const Appointments = () => {
  const [items, setItems] = useState([]);
  const load = () => api.get("/crm/appointments").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line

  const setStatus = async (id, status) => {
    await api.patch(`/crm/appointments/${id}`, { status });
    load();
  };

  return (
    <CRMLayout>
      <div className="mb-6" data-testid="crm-appointments-page">
        <div className="overline text-gold">Schedule</div>
        <h1 className="font-display text-3xl text-navy mt-2">Appointments</h1>
      </div>
      <div className="bg-white border border-slate-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200 text-xs uppercase tracking-wider text-slate-500">
            <tr>
              <th className="text-left p-3">When</th>
              <th className="text-left p-3">Client</th>
              <th className="text-left p-3">Subject</th>
              <th className="text-left p-3">Status</th>
              <th className="text-left p-3"></th>
            </tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-b border-slate-100" data-testid={`apt-row-${a.id}`}>
                <td className="p-3">
                  <div className="text-navy font-semibold">{new Date(a.date).toLocaleString()}</div>
                </td>
                <td className="p-3">
                  <div className="font-semibold text-navy">{a.client_name}</div>
                  <div className="text-xs text-slate-400">{a.client_email} · {a.client_phone || "—"}</div>
                </td>
                <td className="p-3">{a.subject}</td>
                <td className="p-3">
                  <span className={`text-xs px-2 py-1 uppercase tracking-wider font-semibold ${STATUS_COLOR[a.status]}`}>{a.status}</span>
                </td>
                <td className="p-3 space-x-2">
                  {a.status !== "approved" && <button onClick={() => setStatus(a.id, "approved")} className="text-xs text-emerald-700" data-testid={`apt-approve-${a.id}`}>Approve</button>}
                  {a.status !== "rescheduled" && <button onClick={() => setStatus(a.id, "rescheduled")} className="text-xs text-blue-700" data-testid={`apt-reschedule-${a.id}`}>Reschedule</button>}
                  {a.status !== "cancelled" && <button onClick={() => setStatus(a.id, "cancelled")} className="text-xs text-red-500" data-testid={`apt-cancel-${a.id}`}>Cancel</button>}
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="5" className="p-6 text-center text-slate-500">No appointments scheduled.</td></tr>}
          </tbody>
        </table>
      </div>
    </CRMLayout>
  );
};

export default Appointments;
